module.exports = __webpack_public_path__ + "static/media/toyota.6682c5d9.jpg";